export const REGIONS = {
  tshk: 'region_tshk',   // Ташкент и область / Toshkent / Tashkent
  adj: 'region_adj',     // Андижанская / Andijon / Andijan
  bkh: 'region_bkh',     // Бухарская / Buxoro / Bukhara
  frgn: 'region_frgn',   // Ферганская / Farg‘ona / Fergana
  djzk: 'region_djzk',   // Джизакская / Jizzax / Jizzakh
  kshk: 'region_kshk',   // Кашкадарьинская / Qashqadaryo / Kashkadarya
  nmng: 'region_nmng',   // Наманганская / Namangan / Namangan
  nvsk: 'region_nvsk',   // Навоийская / Navoiy / Navoi
  smrk: 'region_smrk',   // Самаркандская / Samarqand / Samarkand
  srkh: 'region_srkh',   // Сурхандарьинская / Surxondaryo / Surkhandarya
  srd: 'region_srd'      // Сырдарьинская / Sirdaryo / Syrdarya
}

export const REGION_PATTERNS = [
  { code: 'bkh', keywords: ['buxoro', 'bukhara', 'бухара', 'бухарск'] },
  { code: 'smrk', keywords: ['samarqand', 'samarkand', 'самарканд'] },
  { code: 'frgn', keywords: ['fargona', "farg'ona", 'farg’ona', 'fergana', 'фергана', 'ферганск'] },
  { code: 'nmng', keywords: ['namangan', 'наманган'] },
  { code: 'nvsk', keywords: ['navoiy', 'navoi', 'навои', 'навоийск'] },
  { code: 'djzk', keywords: ['jizzax', 'jizzakh', 'джизак'] },
  { code: 'adj', keywords: ['andijon', 'andijan', 'андижан'] },
  { code: 'srd', keywords: ['sirdaryo', 'syrdarya', 'сырдарья', 'сырдарьинск'] },
  { code: 'kshk', keywords: ['qashqadaryo', 'kashkadarya', 'кашкадарья', 'кашкадарьинск'] },
  { code: 'srkh', keywords: ['surxondaryo', "surxondar'yo", 'surkhandarya', 'сурхандарья', 'сурхандарьинск', 'термез', 'termez', 'termiz'] },
  { code: 'tshk', keywords: ['toshkent', 'tashkent', 'ташкент'] }
];